/* =========================================================
   CUSTOM SCRIPT: Menu link open in new tab if external to samsclub.com
   ========================================================= */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href="https://www.samsclub.com/ip/Red-House-Roasters-Founders-Reserve-Medium-Roast-Whole-Bean-Coffee-27-oz/20031123603?classType=REGULAR&from=/search"]').forEach(function(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});

/* =========================================================
   CUSTOM SCRIPT: Stable anchor IDs for Brew Method cards
   Added: July 2026
   Purpose: Assigns fixed, hand-controlled IDs to the brew
   method cards (Drip Coffee / French Press / Espresso / Cold
   Brew) so the "SELECT YOUR BREW METHOD" tab links keep working
   even after theme updates regenerate Shopify's own auto IDs.
   Re-runs on resize since the page has separate desktop/mobile
   duplicate grids, and only one should hold the ID at a time.
   Scoped to only run on pages that contain this grid.
   ========================================================= */
(function () {
  var brewPages = [
    '/pages/home-brewing-for-newbies',
    '/pages/founders'
  ];

  if (!brewPages.includes(window.location.pathname)) return;

  var anchors = {
    'Drip Coffee': 'brew-drip-coffee',
    'French Press': 'brew-french-press',
    'Espresso': 'brew-espresso',
    'Cold Brew': 'brew-cold-brew'
  };

  function assignAnchorIds() {
    var candidates = document.querySelectorAll(
      'h1, h2, h3, h4, h5, .text-block, [class*="card"] *'
    );

    // Clear any previous assignment first so a hidden duplicate
    // (from before a resize) never holds onto the ID
    Object.values(anchors).forEach(function (id) {
      var existing = document.getElementById(id);
      if (existing) existing.removeAttribute('id');
    });

    candidates.forEach(function (el) {
      var text = el.textContent.trim();
      var anchorId = anchors[text];

      if (!anchorId) return;
      if (document.getElementById(anchorId)) return; // already claimed this pass
      if (el.offsetParent === null) return; // hidden at this breakpoint

      el.id = anchorId;
    });
  }

  // Build an uppercase lookup once so link titles like "DRIP COFFEE"
  // (used on the mobile slider's link markup) match the same keys
  // as the anchors map above ("Drip Coffee").
  var anchorsByUppercaseTitle = {};
  Object.keys(anchors).forEach(function (label) {
    anchorsByUppercaseTitle[label.toUpperCase()] = anchors[label];
  });

  // The mobile brew-method slider ("element--hide-on-desk") links
  // to Shopify's raw block IDs (e.g. #element-XXXX__grid_text_yyyy)
  // instead of the stable #brew-drip-coffee style anchors used by
  // the desktop slider. Those raw IDs drift and break any time the
  // target block is edited, duplicated, or reordered. Rather than
  // chase the ID, rewrite the link to point at the stable anchor,
  // matched by the link's title/text (same labels as the map above).
  function fixMobileSliderLinks() {
    document.querySelectorAll('a[href^="#element-"]').forEach(function (link) {
      var label = (link.getAttribute('title') || link.textContent || '').trim().toUpperCase();
      var anchorId = anchorsByUppercaseTitle[label];
      if (!anchorId) return;

      link.setAttribute('href', '#' + anchorId);
    });
  }

  function init() {
    assignAnchorIds();
    fixMobileSliderLinks();
  }

  // Debounce so this doesn't fire dozens of times while dragging
  // a browser window edge
  var resizeTimer;
  function debouncedAssign() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', debouncedAssign);
})();